import React, { useEffect, useState } from 'react'
import CodeMirror from '@uiw/react-codemirror';
import { okaidia } from '@uiw/codemirror-theme-okaidia';
import ActionSideBar from "../ActionsSideBar/ActionSideBar.js"
import { githubDark } from '@uiw/codemirror-theme-github';
import "../Actions/Actions.scss"
import ActionSearch from '../ActionSearch/ActionSearch.js';

export const Actions = () => {
    const [projects, setProjects] = useState([])
    const [activeProject, setActiveProject] = useState("")
    const [activeFiles, setActiveFile] = useState([])
    const [activeChatBot, setActiveChatBot] = useState("");
    const [selectedFile, setSelectedFile] = useState([])
    const [code, setCode] = useState("")
    // const [selectedFiles,setFiles]=useState([])
    const [config, setConfig] = useState({
        action: "ANALYSIS",
        searchKeys: "",
        files: []
    })
    // const handleKeyDown = (e) => {
    //     if (e.key === "Enter") {
    //     //   submitChat(config.searchKeys, );
    //     performAction(config)
    //     }
    //   };
    const performAction = async (config) => {
        // console.log(config);
        setActiveChatBot("Please hold on while I work on this....")
        const payload = {
            question: config.searchKeys,
            action: config.action,
            files: config.files
        };
        const endpoint = `${process.env.REACT_APP_API_URL}/app_routers/projects/${activeProject}/actions`;
        const response = await fetch(endpoint, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
        });
        const reader = response.body.getReader();
        const decoder = new TextDecoder();
        let accumulatedText = "";

        for (let done = false; !done;) {
            const { done: streamDone, value } = await reader.read();
            done = streamDone;
            if (value) {
                const text = decoder.decode(value, { stream: true });
                accumulatedText += text;
                setActiveChatBot(accumulatedText)
            }
        }



    }

    const fetchProjects = async () => {
        try {
            const response = await fetch(
                `${process.env.REACT_APP_API_URL}/app_routers/projects`
            );
            const result = await response.json();
            const names = result.map((item) => item.project_name);
            setProjects(names);
            setActiveProject(names[0])
        } catch (error) {
            console.log("Error :", error);
        }
    };
    const setActiveFiles = async () => {
        if (activeProject != "") {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/app_routers/projects/${activeProject}/names`)
                const data = await response.json()
                // console.log(data);
                const files = data.map((item) => item.name)
                // console.log(files);
                setActiveFile(files)
                setSelectedFile([files[0]])
            }
            catch (err) {
                console.log("Error in fetching files", err);
            }
        }
    }
    const fetchFileContent = async () => {
        if (selectedFile.length > 0 && activeProject != "") {
            console.log("file name" + selectedFile);
            if (Array.isArray(selectedFile)) {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/app_routers/projects/${activeProject}/names/${selectedFile[0]}`)
                const data = await response.json()
                console.log(data);
                setCode(data.fileContent)
            }
            else {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/app_routers/projects/${activeProject}/names/${selectedFile}`)
                const data = await response.json()
                setCode(data.fileContent)
            }
        }

    }


    useEffect(() => {
        fetchProjects()
    }, [])

    useEffect(() => {
        setActiveFiles()
    }, [activeProject])

    useEffect(() => {
        fetchFileContent()
    }, [selectedFile])


    return (
        <div className='head'>
            <ActionSideBar
                projects={projects}
                activeProject={activeProject}
                handleActiveProject={setActiveProject}
                activeProjectFiles={activeFiles}
                setFile={setSelectedFile}
                selectedFile={selectedFile}
                config={config}
                setConfig={setConfig}
                performAction={performAction}
            />
            <div className='content'>
              
                <CodeMirror
                    className='data'
                    value={code}
                    theme={okaidia}
                    height='100vh'
                    options={{
                        lineNumbers: true,
                        tabSize: 2,
                        indentWithTab: true,
                        lineWrapping: true,
                    }}
                />
                  <ActionSearch
                    config={config}
                    setConfig={setConfig}
                    performAction={performAction}
                    selectedFile={selectedFile}
                />
                <div className='AI'>
                    <CodeMirror
                        value={activeChatBot === "" ? "Hi there! 😊 I'm your friendly assistant.\n How can I help you today? Feel free to ask me anything!" : activeChatBot}
                        theme={githubDark}
                        options={{
                            lineNumbers: true,
                            tabSize: 2,
                            indentWithTab: true,
                            lineWrapping: true,
                        }}
                    />
                </div>
            </div>
        </div>

    )
}
